// extracted by mini-css-extract-plugin
module.exports = {"container":"WalletTag_container__UqFsd","selected":"WalletTag_selected__nWZZz","normal":"WalletTag_normal__rqiEv"};